import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import FloatingRFQ from "@/components/site/FloatingRFQ";

export default function Layout() {
  return (
    <div className="min-h-screen bg-white text-[#171717]">
      <Navbar />
      <main><Outlet /></main>
      <Footer />
      <FloatingRFQ />
    </div>
  );
}